module.exports = __webpack_public_path__ + "static/media/muchtodo-logo.8cfa2c7a.png";